import React from 'react';
import {
  ButtonVariant, Icon, IconName,
} from '@usealloy/component-library';
import { StyledSearchTrigger, StyledTooltip } from './styles';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { selectIsSearchBoxVisible } from 'flow/store/redux/selectors';
import { setIsSearchBoxVisible } from 'flow/store/redux/slice';
import { useKeyboardKeyEvent } from '../../WorkflowCanvas/hooks';
import { closeSearchBoxThunk } from 'flow/store/redux/thunks';
import { getBrowserOS } from 'flow/service/util';
import { isPrimaryModifierPressed } from '../helpers';

export default function SearchTrigger({
  variant = ButtonVariant.secondary,
}: {
  variant?: ButtonVariant;
}) {
  const dispatch = useAppDispatch();

  const isSearchBoxVisible = useAppSelector(selectIsSearchBoxVisible);
  const browserOS = getBrowserOS();

  const openSearchBox = () => dispatch(setIsSearchBoxVisible(true));
  const closeSearchBox = () => dispatch(closeSearchBoxThunk());

  const handleClick = () => {
    if (!isSearchBoxVisible) {
      openSearchBox();
    }
  };

  useKeyboardKeyEvent('f', event => {
    if (isPrimaryModifierPressed(event)) {
      // prevent the browser's search box from appearing
      event.preventDefault();
      if (!isSearchBoxVisible) {
        openSearchBox();
      }
    }
  });

  useKeyboardKeyEvent('Escape', () => {
    if (isSearchBoxVisible) {
      closeSearchBox();
    }
  });

  const keyboardHintText = browserOS === 'mac' ? '(cmd + F)' : '(ctrl + F)';
  return (
    <StyledTooltip
      content={<>Search this Workflow<br />{keyboardHintText}</>}
    >
      <StyledSearchTrigger variant={variant} onClick={handleClick}>
        <Icon icon={IconName.Search} />
      </StyledSearchTrigger>
    </StyledTooltip>
  );
}
